<template>
	<div
		class="modal unavailability-modal"
		:class="{ 'modal--dark': darkTheme }"
		@click="close"
	>
		<div class="modal-holder" @click.stop>
			<span class="modal-title">
				{{ orderType }} Orders Are Currently Unavailable
			</span>
			<span
				v-if="isAvailableTimeExist"
				class="table-side-ordering-unavailable-caption"
			>
				Next availability
			</span>
			<span
				v-if="isAvailableTimeExist"
				class="table-side-ordering-unavailable-time"
			>
				{{ nextAvailableDay }}
				{{ getAmPmTime(availablePeriod.startTime, AMPMFormat) }} -
				{{ getAmPmTime(availablePeriod.endTime, AMPMFormat) }}
			</span>
			<div class="modal-additional-info">
				You can place an order at the bar or with a server
			</div>
			<template v-if="!isLoading">
				<div v-if="actionText" class="modal-buttons">
					<div class="button" @click="onAction">
						{{ actionText }}
					</div>
					<div class="button" @click="close">
						Ok
					</div>
				</div>
				<div v-else class="modal-button simple-button">
					<div class="button" @click="close">
						Ok
					</div>
				</div>
			</template>
			<div v-else class="modal-button simple-button">
				<div class="button loading">
					Loading …
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getAmPmTime } from '@/utils/helpers'

import { mapState } from 'vuex'
import { isEmpty } from 'lodash'
import { DAYS_LIST, AMPM_FORMAT } from '@/constants'

export default {
	name: 'UnavailabilityModal',

	props: {
		action: {
			type: Function,
			default: () => {}
		},

		actionText: {
			type: String,
			default: ''
		},

		orderType: {
			type: String,
			default: ''
		},

		availablePeriod: {
			type: Object,
			default: () => ({})
		},

		isLoading: {
			type: Boolean,
			default: false
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		...mapState('venue', ['venueInfo', 'currentDow']),

		AMPMFormat() {
			return AMPM_FORMAT
		},

		timeZone() {
			return this.venueInfo.timeZone
		},

		isAvailableTimeExist() {
			return !isEmpty(this.availablePeriod)
		},

		nextAvailableDay() {
			const dayNextAvailability = this.availablePeriod.dow
			return this.currentDow !== dayNextAvailability
				? DAYS_LIST[dayNextAvailability]
				: ''
		}
	},

	methods: {
		getAmPmTime,

		onAction() {
			this.$emit('on-action', this.action)
		},

		close() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss">
.unavailability-modal {
	display: flex;
	align-items: center;
	justify-content: center;

	.modal-holder {
		display: block;
		padding-bottom: 0;

		.modal-title {
			padding-bottom: 0;
			margin-bottom: 18px;
		}

		.table-side-ordering-unavailable-caption {
			display: block;
			color: #1d1b25;
			padding-bottom: 0;
			margin-bottom: 4px;
		}

		.table-side-ordering-unavailable-time {
			display: block;
			padding-bottom: 10px;
			margin-bottom: 10px;
			color: #1d1b25;
			font-weight: 600;
			font-size: 16px;
			line-height: 22px;
			border-bottom: 1px dashed rgba(#1d1b25, 0.6);
		}

		.modal-additional-info {
			margin-bottom: 18px;
			color: rgba(#1d1b25, 0.8);
			font-size: 14px;
			line-height: 20px;
			text-align: center;
		}

		.modal-buttons,
		.modal-button {
			margin: 0 -20px 0 -20px;

			.button {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				padding: 10px;
				height: 48px;
				border-radius: 0 0 10px 10px;

				&.loading {
					opacity: 0.5;
				}
			}
		}

		.modal-buttons {
			display: flex;
			justify-content: space-between;

			.button {
				width: calc(50% - 1px);
				border-radius: 0 0 10px 0;

				&:first-child {
					border-radius: 0 0 0 10px;
				}
			}
		}
	}
}
</style>
